import { Col, Container, Row } from 'react-bootstrap'
import './Footer.css'
import udemyPic from '../../assets/images/udemyLogo.png'

function Footer() {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#000552ff" fillOpacity="1" d="M0,96L30,85.3C60,75,120,53,180,53.3C240,53,300,75,360,117.3C420,160,480,224,540,224C600,224,660,160,720,128C780,96,840,96,900,128C960,160,1020,224,1080,250.7C1140,277,1200,267,1260,234.7C1320,203,1380,149,1410,122.7L1440,96L1440,320L1410,320C1380,320,1320,320,1260,320C1200,320,1140,320,1080,320C1020,320,960,320,900,320C840,320,780,320,720,320C660,320,600,320,540,320C480,320,420,320,360,320C300,320,240,320,180,320C120,320,60,320,30,320L0,320Z"></path></svg>
            <footer className='pb-3' >
                <Container>
                    <Row className='py-3'>
                        <Col className='text-color'>
                            <h2 className='vidalokaFont'>Explore top skills and certifications in Udemy</h2>
                            <p style={{ fontSize: '18px' }}>Top companies choose Udemy Business to build in-demand career skills 💗</p>
                        </Col>
                        <Col style={{ textAlign: 'right' }} >
                            <img className='img-logo' src={udemyPic} alt="udemy-logo" />
                        </Col>
                    </Row>
                </Container>
            </footer>

        </>
    )
}

export default Footer